<template>
  <div v-if="isVisible" class="modal-overlay">
    <div class="modal-content">
      <h4>Sesión Expirada</h4>
      <p>
        Tu sesión ha caducado. Por favor, inicia sesión de nuevo para continuar.
      </p>
      <button @click="handleConfirm" class="confirm-button">Aceptar</button>
    </div>
  </div>
</template>

<script>
import {
  modalStore,
  hideSessionExpiredModalComp,
} from "@/stores/modalstore.js";

export default {
  name: "SessionExpiredModalComp",
  computed: {
    isVisible() {
      return modalStore.isSessionExpiredModalCompVisible;
    },
  },
  methods: {
    handleConfirm() {
      if (typeof modalStore.onSessionExpiredConfirm === "function") {
        modalStore.onSessionExpiredConfirm();
      }
      hideSessionExpiredModalComp();
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* Un z-index muy alto para estar por encima de todo */
}

.modal-content {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.4);
  width: 90%;
  max-width: 400px;
  text-align: center;
}

.modal-content h4 {
  margin-top: 0;
  color: var(--color-acento-secundario);
  margin-bottom: 1rem;
}

.modal-content p {
  margin-bottom: 1.5rem;
  color: #666;
}

.confirm-button {
  background-color: var(--color-acento-primario);
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 30px;
  cursor: pointer;
  font-weight: bold;
  font-size: 1rem;
  transition: background-color 0.2s;
  width: 100%;
  margin-top: 1rem;
}

.confirm-button:hover {
  background-color: var(--color-acento-primario-suave);
}
</style>
